module.exports = __webpack_public_path__ + "static/media/bg_trial_resumption_from_45_to_49.d7e3af5e.webp";